import type { TabsState, DrawTabId, VideoHeightState } from './types';

import type { StateCreator } from '@shared-types/zustand.types';

export const tabsSlice: StateCreator<TabsState> = (set) => ({
  tab: null as DrawTabId,
  setTab: (tab?: DrawTabId) => set(() => ({ tab }), false, 'setTab'),
});

export const videoHeightSlice: StateCreator<VideoHeightState> = (set) => ({
  videoHeight: 0 as number,
  setVideoHeight: (videoHeight?: number) => set(() => ({ videoHeight })),
});
